import { Resource as h, API as u } from "@coveo/platform-client";
import { shouldMockBatchAnswer as o } from "../ShouldMockBatchAnswer.js";
import { createMockBatchAnswerRunsListResponse as $, createMockBatchAnswerRunItem as w, createMockBatchAnswerRunResultResponse as M } from "./BatchAnswerEvaluationRuns.mocks.js";
const s = 2e3, d = 10, n = class n extends h {
  list(i, t, e) {
    return o(e == null ? void 0 : e.isMocking) ? new Promise((l) => {
      setTimeout(() => {
        l(
          $(
            (e == null ? void 0 : e.nbOfMockEntry) ?? d,
            t == null ? void 0 : t.page,
            t == null ? void 0 : t.perPage
          )
        );
      }, s);
    }) : this.api.get(
      this.buildPath(`${n.baseUrl}/${i.evaluationId}/runs`, t)
    );
  }
  create(i, t, e) {
    return o(e == null ? void 0 : e.isMocking) ? new Promise((l) => {
      setTimeout(() => {
        l(w(0));
      }, 200);
    }) : this.api.post(
      `${n.baseUrl}/${i.evaluationId}/runs`,
      t
    );
  }
  delete(i, t) {
    return o(t == null ? void 0 : t.isMocking) ? new Promise((e) => {
      setTimeout(() => {
        e();
      }, s);
    }) : this.api.delete(`${n.baseUrl}/${i.evaluationId}/runs/${i.runId}`);
  }
  updateNotes(i, t, e) {
    return o(e == null ? void 0 : e.isMocking) ? new Promise((l) => {
      setTimeout(() => {
        l();
      }, s);
    }) : this.api.put(
      `${n.baseUrl}/${i.evaluationId}/runs/${i.runId}/notes`,
      t
    );
  }
  results(i, t, e) {
    return o(e == null ? void 0 : e.isMocking) ? new Promise((l) => {
      setTimeout(() => {
        l(
          M(
            d,
            t == null ? void 0 : t.page,
            t == null ? void 0 : t.perPage
          )
        );
      }, s);
    }) : this.api.get(
      this.buildPath(`${n.baseUrl}/${i.evaluationId}/runs/results`, t)
    );
  }
};
n.baseUrl = `/rest/organizations/${u.orgPlaceholder}/answer/v1/evaluations`;
let p = n;
export {
  p as EvaluationRunResource
};
//# sourceMappingURL=BatchAnswerEvaluationRuns.resource.js.map
